import React from "react";

const EDPNewExcelEntry = ({ newEntry, title }) => {
  // const plateform = handleApiredirectionAndTheme(
  //   window.location.host
  // ).plateform;

  // const plateform = RedirectionHandler[window.location.host]?.plateform;

  // Ensure newEntry is always an array
  const safeEntry = Array.isArray(newEntry) ? newEntry : [];

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-2">{title || "EDP Status Report"}</h2>
      {title === "Pending Report" ? (
        <table className="min-w-full text-sm text-left text-gray-500">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-2 px-4">Order Date</th>
              <th className="py-2 px-4">Order No</th>
              <th className="py-2 px-4">Model</th>
              <th className="py-2 px-4">Variant</th>
              <th className="py-2 px-4">Color</th>
              <th className="py-2 px-4">VIN No.</th>
              <th className="py-2 px-4">Order Status</th>
            </tr>
          </thead>
          <tbody>
            {safeEntry.length > 0 ? (
              safeEntry.map((entry, index) => (
                <tr key={index} className="border-b">
                  <td className="py-2 px-4">{entry.OrderDate || entry.order_date || "-"}</td>
                  <td className="py-2 px-4">{entry.OrderNo || entry.order_no || "-"}</td>
                  <td className="py-2 px-4">{entry.Model || entry.model || entry.model_name || "-"}</td>
                  <td className="py-2 px-4">{entry.Variant || entry.variant || "-"}</td>
                  <td className="py-2 px-4">{entry.Color || entry.color || entry.colour || "-"}</td>
                  <td className="py-2 px-4">{entry.VinNo || entry.vin_no || entry.win_num || "-"}</td>
                  <td className="py-2 px-4">{entry.OrderStatus || entry.order_status || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="py-4 text-center text-xs text-gray-500">
                  No entries available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      ) : (
        safeEntry.length > 0 ? (
          <table className="min-w-full text-sm text-left text-gray-500">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="py-2 px-4">Order No</th>
                <th className="py-2 px-4">VIN Number</th>

                <th className="py-2 px-4">Model</th>
                <th className="py-2 px-4">Color</th>
                <th className="py-2 px-4">Variant</th>
                <th className="py-2 px-4">Fuel Type</th>
                <th className="py-2 px-4">YOM</th>
                <th className="py-2 px-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {safeEntry.map((entry, index) => (
                <tr key={index} className="border-b">
                  <td className="py-2 px-4">{entry.OrderId || entry.order_no || entry.OrderNo || "-"}</td>
                  <td className="py-2 px-4">{entry.win_num}</td>

                  <td className="py-2 px-4">{entry.model_name}</td>
                  <td className="py-2 px-4">{entry.colour}</td>
                  <td className="py-2 px-4">{entry.variant}</td>
                  <td className="py-2 px-4">{entry.fueltype}</td>
                  <td className="py-2 px-4">{entry.yom}</td>
                  <td className="py-2 px-4">{entry.GDMSExcelStatus}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-xs text-gray-500">No entries available</p>
        )
      )}
    </div>
  );
};

export default EDPNewExcelEntry;
